import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Earrings3D from './components/3D/Earrings';
import Earrings2D from './components/2D/Earrings';
import Necklace3D from './components/3D/Necklace';
import Necklace2D from './components/2D/Necklace';
import Combo3D from './components/3D/Combo';
import Combo2D from './components/2D/Combo';
import ModelViewer from './components/3D/ModelViewer';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/3d/earrings/:sku" element={<Earrings3D />} />
        <Route path="/2d/earrings/:sku" element={<Earrings2D />} />
        <Route path="/3d/necklaces/:sku" element={<Necklace3D />} />
        <Route path="/2d/necklaces/:sku" element={<Necklace2D />} />
        <Route path="/3d/combo/:sku1/:sku2" element={<Combo3D />} />
        <Route path="/2d/combo/:sku1/:sku2" element={<Combo2D />} />
        <Route path="/view/combo/:sku1/:sku2" element={<ModelViewer />} />
        <Route path="/view/:category/:sku" element={<ModelViewer />} />
        <Route path="/" element={
          <div className="App">
            <h1>Welcome to Virtual Try-On</h1>
            <p>Please select a category:</p>
            <nav>
              <Link to="/3d/earrings/26" style={{ marginRight: '20px' }}>Try Earrings (3D)</Link>
              <Link to="/2d/earrings/26" style={{ marginRight: '20px' }}>Try Earrings (2D)</Link>
              <Link to="/3d/necklaces/1" style={{ marginRight: '20px' }}>Try Necklace (3D)</Link>
              <Link to="/2d/necklaces/1" style={{ marginRight: '20px' }}>Try Necklace (2D)</Link>
              <Link to="/3d/combo/1/26" style={{ marginRight: '20px' }}>Try Combo (3D)</Link>
              <Link to="/2d/combo/500/500" style={{ marginRight: '20px' }}>Try Combo (2D)</Link>
              <Link to="/view/earrings/26" style={{ marginRight: '20px' }}>View Earrings 3D</Link>
              <Link to="/view/necklaces/1" style={{ marginRight: '20px' }}>View Necklace 3D</Link>
              <Link to="/view/combo/1/26" style={{ marginRight: '20px' }}>View Combo 3D</Link>
            </nav>
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
